export default "__VITE_ASSET__DhPW3Wdg__"